/** Menu blips (04 §5): short square figures, as a cabinet's service menu beeped. Pure. */

import { midiToHz } from '../notes';
import { vary } from '../rand';
import { adsr, type VoiceSpec } from '../voice';
import { hit, run, type Sfx, tone } from './kit';

/** Moving through a menu: the smallest tick, B5. */
export const move: Sfx = (r) => [
  { ...hit('pulse', vary(r, midiToHz(83), 0.01), 0.04, 0.13), width: 0.5 },
];

/** Choosing: three notes up, a fifth then a fourth. */
export const select: Sfx = () => [{ ...run('pulse', [79, 86, 91], 0.04, 0.14, 0.2), width: 0.25 }];

/** Going back: the same three coming down. */
export const back: Sfx = () => [{ ...run('pulse', [86, 79, 74], 0.04, 0.14, 0.18), width: 0.25 }];

/** Not allowed: a short low buzz, two squares a semitone apart beating. */
export const error: Sfx = () => {
  const buzz = (hz: number): VoiceSpec => ({
    ...tone('pulse', hz, 0.14, adsr(0.002, 0.05, 0.8, 0.04), 0.1),
    width: 0.5,
    filter: { type: 'lowpass', freq: 1200, q: 0 },
  });
  return [buzz(98), buzz(104)];
};

/** A letter set in the initials: a thin click. */
export const type: Sfx = (r) => [
  { ...hit('pulse', vary(r, 2400, 0.08), 0.02, 0.14), width: 0.125 },
];
